import BasicSelect from "components/BasicInputs/BasicSelect";
import BasicTextInput from "components/BasicInputs/BasicTextInput";
import { useFormikContext } from "formik";
import { useMemo } from "react";

export default function Quantity({ row }: { row: MaterialOrderRow }) {
  const data = useFormikContext<MaterialOrderData>();
  const v = data.values;

  const unitOptions = useMemo(() => {
    if (row.Product == undefined) return [];
    const options = [{ label: row.unit, value: row.unit }];
    if (row.subUnit) {
      options.push({ label: row.subUnit, value: row.subUnit });
    }
    return options;
  }, [row.ProductId]);

  return (
    <BasicTextInput
      type="quantity"
      arrowHidden
      min={0}
      style={{ padding: "0px 12px 0px 0px" }}
      val={row.quantity}
      onChange={(val) => {
        const newRows = [...(v.materialsRows || [])];
        const index = newRows.findIndex((x) => x.ind === row.ind);
        if (index > -1 && typeof val === "number") {
          newRows[index] = { ...row, quantity: val };
          data.setFieldValue("materialsRows", newRows);
        }
      }}
      prefix={
        <div className="w-24 my-2 border-r border-gray-200">
          <BasicSelect
            containerStyle={{ minWidth: 60 }}
            menuStyle={{ minWidth: 60 }}
            btnStyle={{ border: "none", minWidth: 60 }}
            defaultValue={row.selectedUnit}
            onChange={(val) => {
              const newRows = [...(v.materialsRows || [])];
              const index = newRows.findIndex((x) => x.ind === row.ind);
              if (index > -1 && typeof val === "string") {
                newRows[index] = { ...row, selectedUnit: val };
                data.setFieldValue("materialsRows", newRows);
              }
            }}
            options={unitOptions}
          />
        </div>
      }
    />
  );
}
